import { Spinner } from "@repo/core/components/core/Spinner";
import { VStack } from "@gluestack-ui/themed";
import { ScaffoldLoadingProps } from "./types";
import { Text } from "@repo/core/components/core/Text";

export const ScaffoldLoading = ({
  title,
  description
}: ScaffoldLoadingProps) => {
  return (
    <VStack
      w="$full"
      h="$full"
      flex={1}
      alignItems="center"
      justifyContent="center"
      gap="$4"
    >
      <Spinner size="large" color="$primary700" />
      <VStack gap="$1" alignItems="center">
        {title && (
          <Text
            fontSize="$lg"
            fontWeight={400}
            fontFamily="inter"
            color="$textDark900"
          >
            {title}
          </Text>
        )}
        {description && (
          <Text
            fontSize="$sm"
            fontWeight={400}
            fontFamily="inter"
            color="$textDark900"
          >
            {description}
          </Text>
        )}
      </VStack>
    </VStack>
  );
};
